import { RouteComponentProps } from "@reach/router";
import * as React from "react";
import { Layout } from "./Layout";
import { RootStatusSummary, SourceType } from "@authory-packages/core";
import { Api } from "../lib/api";
import { SourceHealthChart } from "../components/SourceTypeHealthChart";
import { Grid } from "@material-ui/core";
import { useUserSession } from "../lib/session";

const sortingArr = [
  SourceType.Web,
  SourceType.PodcastRssFeed,
  SourceType.Sitemap,
  SourceType.RssFeed,
  SourceType.Youtube,
  SourceType.EntireInternet,
  SourceType.Facebook,
  SourceType.Instagram,
  SourceType.Twitter,
  SourceType.Unsupported,
  SourceType.Linkedin,
  SourceType.Offline,
];

export const DashboardPage: React.FC<RouteComponentProps> = (props) => {
  const [rootStatus, setRootStatus] = React.useState<RootStatusSummary[]>([]);
  const { session } = useUserSession();

  React.useEffect(() => {
    const fetchData = async () => {
      const resp = await Api.getRootStatus();

      if (resp.status !== 200) {
        throw new Error(
          `Fetching durga status failed: ${resp.status}: ${resp.statusText}`
        );
      }

      setRootStatus(
        resp.data.aggregated.sort((a, b) => {
          return sortingArr.indexOf(a.type) - sortingArr.indexOf(b.type);
        })
      );
    };

    fetchData().catch(console.error);
  }, []);

  return (
    <Layout title="Dashboard">
      <h1>Welcome {session?.firstName || "Admin"}!</h1>
      <p>
        Please find the import system health below. Blue means healthy, red
        (inner circle) means error, orange (outer circle) represents delays.
      </p>
      <Grid container spacing={2}>
        {rootStatus.map((data) => (
          <Grid item xs={4}>
            <SourceHealthChart
              all={data.allCount}
              delayed={data.delayedCount}
              errored={data.errorCount}
              label={data.type}
            />
          </Grid>
        ))}
      </Grid>
    </Layout>
  );
};
